import {Component, OnInit, OnDestroy} from '@angular/core';
import {AirportsSliderElComponent} from './airports-slider-el/airports-slider-el.component';
import {NgForOf, NgIf} from '@angular/common';
import { Location } from '@angular/common';
import {Airport} from '../../../model/airport';
import {StorageService} from '../../../services/storage.service';
import {Subscription} from 'rxjs';
import { Router } from '@angular/router';
import { LanguageService } from '../../../services/language.service';
import {CdkDragDrop, DragDropModule, moveItemInArray} from '@angular/cdk/drag-drop';
import { AirportService } from '../../../services/airport.service';


@Component({
  selector: 'app-airports-slider',
  imports: [
    AirportsSliderElComponent,
    NgForOf,
    NgIf,
    DragDropModule,
  ],
  templateUrl: './airports-slider.component.html',
  styleUrl: './airports-slider.component.scss'
})
export class AirportsSliderComponent implements OnInit, OnDestroy {

  constructor(
    private location: Location,
    private storageService: StorageService,
    private router: Router,
    public languageService: LanguageService,
    public airportService: AirportService
  ) {}

  activeIndex: number = 0;
  selectedAirports: Airport[] = [];
  serviceValidationSubmitted = false;
  private storageSubscription: Subscription | null = null;
  private validationSubscription: Subscription | null = null;
  bookingValidationSubmitted = false;
  private bookingValidationSubscription: Subscription | null = null;

  ngOnInit() {
    this.storageSubscription = this.storageService.airports$.subscribe(airports => {
      this.selectedAirports = airports;

      const activeIndex = this.selectedAirports.findIndex(
        airport => airport.active
      );

      this.activeIndex = activeIndex !== -1 ? activeIndex : 0;
    });

    this.validationSubscription = this.storageService.serviceValidationSubmitted$
      .subscribe(value => {
        this.serviceValidationSubmitted = value;
      });

    this.bookingValidationSubscription = this.storageService.bookingValidationSubmitted$
      .subscribe(value => {
        this.bookingValidationSubmitted = value;
      });

  }

  ngOnDestroy() {
    this.storageSubscription?.unsubscribe();
    this.validationSubscription?.unsubscribe();
    this.bookingValidationSubscription?.unsubscribe();
  }

  private loadAirports(): void {
    this.storageService.getAirports().subscribe(airports => {
      this.selectedAirports = airports;
    });
  }

  get isVisible(): boolean {
    if (this.selectedAirports.length === 0) return false;
    const currentPath = this.location.path();
    return !(
      currentPath === '/contact' ||
      currentPath.includes('/contact') ||
      currentPath.includes('/chat') ||
      currentPath === '' ||
      currentPath === '/about' ||
      currentPath.includes('/success') ||
      currentPath.includes('/checkout') ||
      currentPath.includes('/admin') ||
      currentPath.includes('/login')
    );
  }

  get routeAirports(): Airport[] {
    return this.storageService.getRouteAirports();
  }

  get departureAirports(): Airport[] {
    return this.selectedAirports.filter(airport =>
      airport.routeRole === 'departure'
    );
  }

  get transitAirports(): Airport[] {
    return this.selectedAirports.filter(airport =>
      airport.routeRole === 'transit'
    );
  }

  get arrivalAirports(): Airport[] {
    return this.selectedAirports.filter(airport =>
      airport.routeRole === 'arrival'
    );
  }

  get unassignedAirports(): Airport[] {
    return this.selectedAirports.filter(airport =>
      !airport.routeRole
    );
  }

  dropRouteAirport(event: CdkDragDrop<Airport[]>): void {
    if (event.previousIndex === event.currentIndex) return;

    const updatedRoute = [...this.routeAirports];

    moveItemInArray(
      updatedRoute,
      event.previousIndex,
      event.currentIndex
    );

    this.storageService.updateRouteAirportsOrder(updatedRoute);
  }

  setActiveAirport(airport: Airport): void {
    const currentPath = this.location.path();

    if (
      currentPath.startsWith('/services') ||
      currentPath.startsWith('/passengers') ||
      currentPath.startsWith('/mobile/services') ||
      currentPath.startsWith('/mobile/passengers')
    ) {
      const updatedRoute = this.routeAirports.map(item => new Airport({
        ...item,
        active: item === airport
      }));
      this.storageService.updateRouteAirportsOrder(updatedRoute);
      return;
    }

    if (!airport?.slug) return;

    const routeCode = this.storageService.getAirportRouteCode(airport);

    this.storageService.setActiveAirport(airport.slug).subscribe(() => {
      if (currentPath.includes('/airport-booking2')) {
        this.router.navigate(['/airport-booking2', routeCode]);
        return;
      }

      this.router.navigate(['/airport', routeCode]);
    });
  }

  get sliderItemsCount(): number {
    return (
      this.routeAirports.length +
      (this.canAddMoreAirports && this.isAirportPage ? 1 : 0)
    );
  }

  // els: AirportSliderEl[] = [
  //   {
  //     countryImg: '/assets/placeholders/uae.png',
  //     airportNameRu: 'Dubai International Airport',
  //     airportNameEn: 'Dubai International Airport',
  //     countryNameRu: 'DXB • United Arab Emirates',
  //     countryNameEn: 'DXB • United Arab Emirates'
  //   },
  //   {
  //     countryImg: '/assets/placeholders/uae.png',
  //     airportNameRu: 'London Heathrow',
  //     airportNameEn: 'London Heathrow',
  //     countryNameRu: 'LHR • United Kingdom',
  //     countryNameEn: 'LHR • United Kingdom'
  //   },
  //   {
  //     countryImg: '/assets/placeholders/uae.png',
  //     airportNameRu: 'Singapore Changi',
  //     airportNameEn: 'Singapore Changi',
  //     countryNameRu: 'SIN • Singapore',
  //     countryNameEn: 'SIN • Singapore'
  //   },
  //   {
  //     countryImg: '/assets/placeholders/uae.png',
  //     airportNameRu: 'Hong Kong International',
  //     airportNameEn: 'Hong Kong International',
  //     countryNameRu: 'HKG • Hong Kong',
  //     countryNameEn: 'HKG • Hong Kong'
  //   },
  //   {
  //     countryImg: '/assets/placeholders/uae.png',
  //     airportNameRu: 'Tokyo Narita',
  //     airportNameEn: 'Tokyo Narita',
  //     countryNameRu: 'NRT • Japan',
  //     countryNameEn: 'NRT • Japan'
  //   },
  //   {
  //     countryImg: '/assets/placeholders/uae.png',
  //     airportNameRu: 'Tokyo Narita',
  //     airportNameEn: 'Tokyo Narita',
  //     countryNameRu: 'NRT • Japan',
  //     countryNameEn: 'NRT • Japan'
  //   },
  //   {
  //     countryImg: '/assets/placeholders/uae.png',
  //     airportNameRu: 'Tokyo Narita',
  //     airportNameEn: 'Tokyo Narita',
  //     countryNameRu: 'NRT • Japan',
  //     countryNameEn: 'NRT • Japan'
  //   },
  //   {
  //     countryImg: '/assets/placeholders/uae.png',
  //     airportNameRu: 'Tokyo Narita',
  //     airportNameEn: 'Tokyo Narita',
  //     countryNameRu: 'NRT • Japan',
  //     countryNameEn: 'NRT • Japan'
  //   },
  //   {
  //     countryImg: '/assets/placeholders/uae.png',
  //     airportNameRu: 'Tokyo Narita',
  //     airportNameEn: 'Tokyo Narita',
  //     countryNameRu: 'NRT • Japan',
  //     countryNameEn: 'NRT • Japan'
  //   },
  // ];

  setActive(index: number) {
    this.activeIndex = index;

    const airport = this.selectedAirports[index];

    if (!airport?.slug) return;

    const routeCode = this.storageService.getAirportRouteCode(airport);

    this.storageService.setActiveAirport(airport.slug).subscribe(() => {
      const currentPath = this.location.path();

      if (currentPath.includes('/airport-booking2')) {
        this.router.navigate(['/airport-booking2', routeCode]);
        return;
      }

      this.router.navigate(['/airport', routeCode]);
    });
  }

  goToAddAirport() {
    if (!this.canAddMoreAirports) return;

    this.router.navigateByUrl('/add-airport');
  }

  removeCurrentAirport(event: MouseEvent) {
    event.stopPropagation();

    const currentRouteCode = this.location.path().split('/').pop();

    if (!currentRouteCode) return;

    const airports = this.storageService.getAirportsSync();

    if (airports.length <= 1) return;

    const currentIndex = airports.findIndex(airport => {
      const routeCode = this.storageService.getAirportRouteCode(airport);
      return routeCode.toUpperCase() === currentRouteCode.toUpperCase();
    });

    this.storageService.removeAirportByRouteCode(currentRouteCode).subscribe(success => {
      if (!success) return;

      const updatedAirports = this.storageService.getAirportsSync();

      let nextAirport: Airport | null = null;

      if (currentIndex < updatedAirports.length) {
        nextAirport = updatedAirports[currentIndex];
      } else {
        nextAirport = updatedAirports[currentIndex - 1];
      }

      if (!nextAirport?.slug) return;

      const nextRouteCode = this.storageService.getAirportRouteCode(nextAirport);

      this.storageService.setActiveAirport(nextAirport.slug).subscribe(() => {
        this.router.navigate(['/airport', nextRouteCode]);
      });
    });
  }
  get isAirportPage(): boolean {
    const path = this.location.path();

    return (
      path.startsWith('/airport/') ||
      path.startsWith('/airport-booking2')
    );
  }
  get canAddMoreAirports(): boolean {
    return this.storageService.canAddAirport();
  }

  hasAirportError(airport: Airport): boolean {
    const path = this.location.path();

    if (!this.isAirportPage) return false;

    if (path.startsWith('/airport-booking2')) {
      if (!this.bookingValidationSubmitted) return false;

      if (
        !airport.id ||
        !this.storageService.airportHasSelectedServices(airport.id)
      ) {
        return false;
      }

      const routeCode =
        this.storageService.getAirportRouteCode(airport);

      return !this.storageService
        .isAirportBookingFormValid(routeCode);
    }

    if (path.startsWith('/airport/')) {
      if (!this.serviceValidationSubmitted) return false;

      return (
        !this.storageService.hasSelectedServices() &&
        airport.active
      );
    }

    return false;
  }

  getCountryFlag(countryCode?: string | null): string {
    if (!countryCode) return '🌐';

    const code = countryCode.toUpperCase();

    if (code.length !== 2) return '🌐';

    return code
      .split('')
      .map(char => String.fromCodePoint(127397 + char.charCodeAt(0)))
      .join('');
  }

  get routeAirportsMobile(): Airport[] {
    return this.routeAirports;
  }

  getAirportCode(airport: Airport): string {
    return (
      airport.iata_code ||
      airport.icao_code ||
      airport.city_code ||
      airport.slug ||
      ''
    ).slice(0, 3).toUpperCase();
  }

  getAirportCity(airport: Airport): string {
    const language = this.languageService.currentLanguage;

    return airport.cityObject?.names?.[language]
      ?? airport.cityObject?.name
      ?? airport.city
      ?? airport.names?.[language]
      ?? airport.name
      ?? '';
  }

  getAirportRoleLabel(airport: Airport): string {
    switch (airport.routeRole) {
      case 'departure':
        return this.languageService.translate(['Departure', 'Вылет']);

      case 'arrival':
        return this.languageService.translate(['Arrival', 'Прилет']);

      case 'transit':
        return this.languageService.translate(['Transit', 'Транзит']);

      default:
        return this.languageService.translate(['Airport', 'Аэропорт']);
    }
  }

  getAirportFlagAlt(airport: Airport): string {
    return airport.countryObject?.name || airport.country_code || '';
  }

  getAirportRoleShortLabel(airport: Airport): string {
    switch (airport.routeRole) {
      case 'departure':
        return this.languageService.translate(['Dep.', 'Выл.']);

      case 'arrival':
        return this.languageService.translate(['Arr.', 'Прил.']);

      case 'transit':
        return this.languageService.translate(['Tr.', 'Тр.']);

      default:
        return '';
    }
  }

  getAirportRoleIconUrl(airport: Airport): string {
    switch (airport.routeRole) {
      case 'departure':
        return 'assets/icons/departure-plane.svg';

      case 'arrival':
        return 'assets/icons/arrival-plane.svg';

      case 'transit':
        return 'assets/icons/transit-icon.svg';

      default:
        return '';
    }
  }

  moveRouteAirport(
    index: number,
    delta: -1 | 1
  ): void {
    const updatedRoute = [...this.routeAirports];
    const targetIndex = index + delta;

    if (
      targetIndex < 0 ||
      targetIndex >= updatedRoute.length
    ) {
      return;
    }

    [updatedRoute[index], updatedRoute[targetIndex]] = [
      updatedRoute[targetIndex],
      updatedRoute[index]
    ];

    this.storageService.updateRouteAirportsOrder(
      updatedRoute
    );
  }

}
